import React, { useState, useEffect, useReducer} from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage, useDebounce } from 'react-use';
import {
  Button,
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import AnswerAction from './AnswerAction';
import useNotif from 'hooks/use-notify-hook';
import PlanContext from './Utils/context.js';
import PlanReducer from './Utils/reducer.js';
import { ACTIONS } from './Utils/action.js';

function Formula ({ answer, scores, auditeeTeams = [], scheduleId, actionTypes = []}) {

  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [cause, setCause] = useState(answer?.CAUSE_DESC ?? ``);
  const [editEv, setEditEv] = useState(false);
  const [evaluate, setEvaluate] = useState(answer?.EVALUATE_DESC ?? null);
  const [attachments, setAttachments] = useState(answer?.answerAttachments ?? []);
  const [isReadonly, setIsReadonly] = useState(true);
  const [actions, dispatchActions] = useReducer(PlanReducer, answer?.answerActions ?? []);

  const handleAddAction = async () => {

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}answer-actions`, {
          ACTION_TYPE_ID: 1,
          ANSWER_ID: answer.ANSWER_ID,
        },
        { headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      dispatchActions({
        type: ACTIONS.CREATE,
        payload: {
          ANSWER_ACTION_ID: response.data.ANSWER_ACTION_ID,
          ACTION_TYPE_ID: response.data.ACTION_TYPE_ID,
          ANSWER_ID: response.data.ANSWER_ID,
        }
      });

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  }

  const handleUpdate = async () => {
    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}answers/${answer.ANSWER_ID}`,
      {
        CAUSE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
        CAUSE_BY: auth.employee.EMP_ID,
        CAUSE_DESC: cause,
      },
      { headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
    );
  }

  const [, cancelCause] = useDebounce(async () => {

    handleUpdate();

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

  }, 2000, [cause]);

  const [, cancelEvaluation] = useDebounce(async () => {

    const data = {
      EVALUATE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
      EVALUATE_BY: auth.employee.EMP_ID,
      EVALUATE_DESC: evaluate,
    };

    const response = await repository.answer(answer.ANSWER_ID, data);

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

  }, 2000, [evaluate]);

  //check temuan for disabled attributes
  const handleReadonly = () => {

    if (answer.index.SCORE_STATUS !== 1) {
      setIsReadonly(false);
    }
  };

  useEffect(() => {
    cancelCause();
    handleReadonly();
    cancelEvaluation();
  }, []);

  return (
    <PlanContext.Provider value={{
      scheduleId,
      answer,
      auditeeTeams,
      actionTypes,
      actions, dispatchActions
    }}>
      <Row>
        {notif}
        <Col md="12">
          <Card>
            <Card.Header>
              <Card.Title as="h4"><a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
              <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md="10">
                  <Form.Group>
                    <Form.Label>Auditee's Answer</Form.Label>
                    <p>{answer.ANSWER_DESC}</p>
                  </Form.Group>
                  <Form.Group>
                    {/* <Form.Label>Auditor's Evaluation</Form.Label>
                    <p>{answer.EVALUATE_DESC ?? 'N/A'}</p> */}
                    <Form.Label>Auditor's Evaluation</Form.Label>
                    <div></div>
                    {!editEv ?
                      <Button onClick={() => {setEditEv(true)}} variant="primary" size='sm'>Edit</Button>
                    :''}
                    {editEv ?
                      <div>
                        <Form.Control
                          value={evaluate}
                          onChange={({ target: { value }}) => setEvaluate(value)}
                          as="textarea"
                          rows={3}
                          isInvalid={evaluate?.length > 4000}
                        />
                        <Form.Text id="passwordHelpBlock" muted>
                          Total characters: {evaluate?.length ?? 0} / 4000
                        </Form.Text>
                      </div>
                    :<p>{evaluate ?? 'N/A'}</p>
                    }
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Root Cause</Form.Label>
                    <Form.Control
                      value={cause}
                      onChange={({ target: { value }}) => setCause(value)}
                      as="textarea"
                      rows={3}
                      disabled={isReadonly}
                    />
                  </Form.Group>
                  {!isReadonly && (
                    <>
                      <Form.Group>
                        <Form.Label>Action Plan's</Form.Label>
                        {actions && actions.length > 0 ? actions.map((item, key) => <AnswerAction key={key} action={item} />) : <p>No action plan defined.</p>}
                      </Form.Group>
                      <Form.Group>
                        <Button onClick={handleAddAction} variant="primary">Add New Action</Button>
                      </Form.Group>
                    </>
                  )}
                </Col>
                <Col md="2">
                  <Form.Group>
                    {attachments ?
                      attachments.map((attachment, key) => (

                        (
                          <>
                            <div className="font-icon-detail">
                            <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`}>{attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}</a>
                            </div>
                          </>
                        )
                      ))
                      : (<p>No attachment uploaded.</p>)
                    }
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Score</Form.Label>
                    <p>{scores.find(item => item.INDEX_ID === answer.INDEX_ID)?.INDEX_ID ?? `n/a`}</p>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </PlanContext.Provider>
  );
}

export default Formula;